<script lang="ts">
    
    import { Marker, Map as Mapbox } from 'mapbox-gl';
    import { getContext, onDestroy, onMount } from "svelte";
    import type { Coords } from '../interfaces';

    export let location: Coords;
    export let color: any = 'rgb(5, 129, 237)';
    export let heading: number = undefined;

    const map = (getContext('getMap') as () => Mapbox)();

    let marker: Marker;

    $:if (marker) {
        marker.getElement().style.backgroundColor = color;
    }

    onMount(() => {
        marker = new Marker({
            element: createUserMarkerElement(),
            anchor: 'center',
            draggable: true
        });

        marker.on('dragend', onDragEnd);
    });

    onDestroy(() => marker?.remove());

    $: updateLocation(marker, location, heading);

    function onDragEnd() {
        const lngLat = marker.getLngLat();

        location = {
            lat: lngLat.lat,
            lon: lngLat.lng
        };
        
    }

    function updateLocation(marker: Marker, location: Coords, heading?: number): void {
        if (!marker || !location) {
            return;
        }
        
        marker.setLngLat(
            location
        );

        const headingElement = marker.getElement().querySelector('.circle') as HTMLElement;

        if (typeof heading === 'number') {
            headingElement.style.setProperty('transform', `rotate(${heading}deg)`);
            headingElement.classList.add('show');
        } else {
            headingElement.classList.remove('show');
        }

        marker.addTo(map);
    }

    function createUserMarkerElement(): HTMLElement {
        const element = document.createElement('div');
        const circle = document.createElement('div');
        const heading = document.createElement('div');
        element.classList.add('user-marker');
        element.style.backgroundColor = color;
        circle.classList.add('circle');
        heading.classList.add('heading');
        element.append(circle, heading);
        return element;
    }

</script>

<style lang="scss">

    :global(.user-marker) {
        border-radius: 50%;
        width: 25px;
        height: 25px;
        // background-color: rgb(5, 129, 237);
    }

    :global(.user-marker .circle) {
        position: relative;
        z-index: 2;
        width: 100%;
        height: 100%;
        border-radius: 50%;
        border: 3px solid #fff;
    }

    :global(.user-marker .heading) {
        background-image: url('/user_heading.svg');
        background-repeat: no-repeat;
        position: absolute;
        transform-origin: bottom;
        width: 107px;
        height: 75px;
        top: -60px;
        left: -41px;
        display: none;
    }

    :global(.user-marker .heading.show) {
        display: block;
    }

</style>
